<template>
    <div class="d-flex flex-wrap justify-content-center align-items-center">
        <div v-for="inactive of inactivePaymentProviders">
            <div v-if="checkPaymentId(inactive.id)">
                <update-account-details :inactive="inactive" class="m-4"/>
            </div>
            <div v-if="inactive.id === PaymentProvider.STRIPEID">
                <div v-if="hasStripeAccount">
                    <update-stripe-account :details-submitted="detailsSubmitted"
                                           :charges-enabled="chargesEnabled"
                                           class="m-4"/>
                </div>
                <div v-else>
                    <create-stripe-account :inactive="inactive" class="m-4"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UpdateStripeAccount from './UpdateStripeAccount.vue'
import CreateStripeAccount from './CreateStripeAccount.vue'
import {PaymentProviderMixin} from '@mixins/payment_providers'
import UpdateAccountDetails from './UpdateAccountDetails.vue'

export default {
    mixins: [PaymentProviderMixin],

    components: {UpdateAccountDetails, CreateStripeAccount, UpdateStripeAccount},

    props: {
        inactivePaymentProviders: Array,
        chargesEnabled: Boolean,
        detailsSubmitted: Boolean,
        hasStripeAccount: Boolean,
    },

    methods: {
        checkPaymentId(id) {
            return (id === this.PaymentProvider.PAYPALID || id === this.PaymentProvider.STRIPEID || id === this.PaymentProvider.GLOBALPAYMENTSID)
        },
    },
}
</script>
